
export const initCart = `mutation createCart($cartInput: CartInput) {
  cartCreate(input: $cartInput) {
    cart {
      id
      createdAt
      updatedAt
      checkoutUrl
      discountCodes {
        applicable
        code
      }
      discountAllocations {
        discountedAmount {
          amount
          currencyCode
        }
      }
      lines(first: 250) {
        edges {
          node {
            id
            quantity
            discountAllocations {
              discountedAmount {
                amount
                currencyCode
              }
            }
            merchandise {
              ... on ProductVariant {
                title
                id
                sku
                availableForSale
                barcode
                selectedOptions {
                  name
                  value
                }
                compareAtPrice {
                  amount
                  currencyCode
                  
                }
                price {
                  amount
                  currencyCode
                }
                image {
                  id 
                  url
                    altText
                }
                product {
                  id
                  handle
                  featuredImage {
                    id
                    altText
                    url
                  }
                  isGiftCard
                  title
                  totalInventory
                  description
                  
                }
                quantityAvailable
              }
            }
            attributes {
              key
              value
            }
          }
        }
      }
      attributes {
        key
        value
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      buyerIdentity {
        email
        phone
        customer {
          id
        }
        countryCode
        deliveryAddressPreferences {
          ... on MailingAddress {
            address1
            address2
            city
            provinceCode
            countryCodeV2
            zip
          }
        }
        preferences {
          delivery {
            deliveryMethod
          }
        }
      }
    }
  }
}`;

export const getCart = `query getCart($cartID: ID!) {
  cart(id: $cartID) {
    id
    createdAt
    updatedAt
    checkoutUrl
    discountCodes {
      applicable
      code
    }
    discountAllocations {
      discountedAmount {
        amount
        currencyCode
      }
    }
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          discountAllocations {
            discountedAmount {
              amount
              currencyCode
            }
          }
          merchandise {
            ... on ProductVariant {
              title
              id
              sku
              availableForSale
              barcode
              selectedOptions {
                name
                value
              }
              compareAtPrice {
                amount
                currencyCode
                
              }
              price {
                amount
                currencyCode
              }
              image {
                id 
                url
                  altText
              }
              product {
                id
                handle
                featuredImage {
                  id
                  altText
                  url
                }
                isGiftCard
                title
                totalInventory
                description
                
              }
              quantityAvailable
            }
          }
          attributes {
            key
            value
          }
        }
      }
    }
    attributes {
      key
      value
    }
    cost {
      totalAmount {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
      totalDutyAmount {
        amount
        currencyCode
      }
    }
    buyerIdentity {
      email
      phone
      customer {
        id
      }
      countryCode
      deliveryAddressPreferences {
        ... on MailingAddress {
          address1
          address2
          city
          provinceCode
          countryCodeV2
          zip
        }
      }
      preferences {
        delivery {
          deliveryMethod
        }
      }
    }
  }
}`

export const addLineItems = `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      id
      createdAt
      updatedAt
      checkoutUrl
      lines(first: 10) {
        edges {
          node {
            id
            quantity
            merchandise {
            ... on ProductVariant {
              title
              id
              sku
              availableForSale
              barcode
              selectedOptions {
                name
                value
              }
              compareAtPrice {
                amount
                currencyCode
                
              }
              price {
                amount
                currencyCode
              }
              image {
                id 
                url
                  altText
              }
              product {
                id
                handle
                productType
                featuredImage {
                  id
                  altText
                  url
                }
                isGiftCard
                title
                totalInventory
                description
                
              }
              quantityAvailable
            }
          }
            attributes {
              key
              value
            }
          }
        }
      }
      attributes {
        key
        value
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const cartLinesUpdate = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
       id
    createdAt
    updatedAt
    checkoutUrl
    discountCodes {
      applicable
      code
    }
    discountAllocations {
      discountedAmount {
        amount
        currencyCode
      }
    }
    lines(first: 250) {
      edges {
        node {
          id
          quantity
          discountAllocations {
            discountedAmount {
              amount
              currencyCode
            }
          }
          merchandise {
            ... on ProductVariant {
              title
              id
              sku
              availableForSale
              barcode
              selectedOptions {
                name
                value
              }
              compareAtPrice {
                amount
                currencyCode
                
              }
              price {
                amount
                currencyCode
              }
              image {
                id 
                url
                  altText
              }
              product {
                id
                handle
                productType
                featuredImage {
                  id
                  altText
                  url
                }
                isGiftCard
                title
                totalInventory
                description
                
              }
              quantityAvailable
            }
          }
          attributes {
            key
            value
          }
        }
      }
    }
    attributes {
      key
      value
    }
    cost {
      totalAmount {
        amount
        currencyCode
      }
      subtotalAmount {
        amount
        currencyCode
      }
      totalTaxAmount {
        amount
        currencyCode
      }
      totalDutyAmount {
        amount
        currencyCode
      }
    }
    buyerIdentity {
      email
      phone
      customer {
        id
      }
      countryCode
      deliveryAddressPreferences {
        ... on MailingAddress {
          address1
          address2
          city
          provinceCode
          countryCodeV2
          zip
        }
      }
      preferences {
        delivery {
          deliveryMethod
        }
      }
    }
    }
    userErrors {
      field
      message
    }
  }
}`

export const getProductById = `query ($id: ID) {
  product(id: $id) {
    id
    availableForSale
    description
    handle
    title
    options {
      name
      values
    }
    featuredImage {
      id
      url
      altText
    }
    priceRange {
      maxVariantPrice {
        amount
        currencyCode
      }
      minVariantPrice {
        amount
        currencyCode
      }
    }
    variants(first: 250) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      nodes {
        id
        title
        price {
          amount
          currencyCode
        }
        availableForSale
        sku
        image {
          id
          url
          altText
        }
        selectedOptions {
          name
          value
        }
      }
    }
  }
}`

export const cartAttributesUpdate = `mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      id
      createdAt
      updatedAt
      checkoutUrl
      attributes {
        key
        value
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const cartDiscountCodesUpdate = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
    cart {
      id
      createdAt
      updatedAt
      checkoutUrl
      discountCodes {
        applicable
        code
      }
      discountAllocations {
        discountedAmount {
          amount
          currencyCode
        }
      }
      lines(first: 250) {
        edges {
          node {
            id
            quantity
            discountAllocations {
              discountedAmount {
                amount
                currencyCode
              }
            }
            merchandise {
              ... on ProductVariant {
                title
                id
                sku
                availableForSale
                barcode
                selectedOptions {
                  name
                  value
                }
                compareAtPrice {
                  amount
                  currencyCode
                  
                }
                price {
                  amount
                  currencyCode
                }
                image {
                  id 
                  url
                    altText
                }
                product {
                  id
                  handle
                  featuredImage {
                    id
                    altText
                    url
                  }
                  isGiftCard
                  title
                  totalInventory
                  description
                  
                }
                quantityAvailable
              }
            }
            attributes {
              key
              value
            }
          }
        }
      }
      attributes {
        key
        value
      }
      cost {
        totalAmount {
          amount
          currencyCode
        }
        subtotalAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        totalDutyAmount {
          amount
          currencyCode
        }
      }
      buyerIdentity {
        email
        phone
        customer {
          id
        }
        countryCode
        deliveryAddressPreferences {
          ... on MailingAddress {
            address1
            address2
            city
            provinceCode
            countryCodeV2
            zip
          }
        }
        preferences {
          delivery {
            deliveryMethod
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`